const billingTypes = [
    {
        id: 1,
        key: 'stala_cena',
        name: "Stała cena"
    },
    {
        id: 2,
        key: 'zmienna_cena',
        name: "Zmienna cena"
    }
];

const userStateTypes = [
    {

        key: 1,
        value: true,
        name: "Aktywny"
    },
    {
        key: 2,
        value: false,
        name: "Nieaktywny"
    }
];

const dateLocales = {
    dayNames: ["Niedziela", "Poniedziałek", "Wtorek", "Środa", "Czwartek", "Piątek", "Sobota"],
    dayNamesShort: ["Nied", "Pon", "Wt", "Śr", "Czw", "Pią", "Sob"],
    dayNamesMin: ["Ni","Pn","Wt","Śr","Czw","Pt","Sb"],
    monthNames: ["Styczeń","Luty","Marzec","Kwiecień","Maj","Czerwiec","Lipiec","Sierpień","Wrzesień","Październik","Listopad","Grudzień"],
    monthNamesShort: ["Sty", "Lut", "Mar", "Kwi", "Maj", "Czer","Lip", "Sie", "Wrz", "Paź", "Lis", "Gru"],
    today: 'Dzisiaj',
    dateFormat: 'yy-mm-dd',
};

export {billingTypes, dateLocales, userStateTypes};
